import { ChangeDetectionStrategy, Component, input, Input } from "@angular/core";
import { injectSelectOpenDarItemCountForResidentWithId } from "../../shared/state/selectors/dar.selectors";

@Component({
	selector: "patient-item",
	templateUrl: "patient-item.component.html",
	styleUrls: ["patient-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class PatientItemComponent {
	// @ts-expect-error TS2564
	@Input() name: string;
	// @ts-expect-error TS2564
	@Input() picture: string;
	// @ts-expect-error TS2564
	@Input() present: boolean;
	readonly residentId = input<string>();
	@Input() showActiveDarItemsIcon = true;

	protected readonly openObservations = injectSelectOpenDarItemCountForResidentWithId(this.residentId);
}
